<template>
    <div class="rectificat">
        <!-- 头部标题 -->
        <CommonHeader :info="headerInfo"></CommonHeader>
        <!-- 整改详情 -->
        <CommonRectificatDetails :info="recitificatInfo"></CommonRectificatDetails>
        <!-- 问题预览 -->
        <CommonPreview :info="previewInfo"></CommonPreview>
        <!-- 问题详情 -->
        <CommonProblemDetails :info="problemDetailsData" style="margin-bottom: 240px;"></CommonProblemDetails>
    </div>
</template>
<script>
import {Toast} from 'vant-green'
import CommonHeader from '@/views/audit/components/CommonHeader'
import CommonRectificatDetails from '@/views/audit/components/CommonRectificatDetails'
import CommonPreview from '@/views/audit/components/CommonPreview'
import CommonProblemDetails from "@/views/audit/components/CommonProblemDetails"
import {timeStampTransformDate,levelTramform,applyStagesTramform,problemTypeTramform} from '@/utils/approve.js'
import {
    getProblemZgMeasuresData,
    getViewByGuidData,
    getRiskDetailsData,
    getUserInfo,
    getInfluenceListData
} from "@/api/approve.js"
export default {
    components: {
        CommonHeader,
        CommonRectificatDetails,
        CommonPreview,
        CommonProblemDetails
    },
    data(){
        return {
            //整改数据存放点
            recitificatApprovalInfo: {},

            //公共头部数据
            headerInfo: {
                title: "整改审批",      //标题

                problemLevel: "",      //问题等级：一级问题、二级问题、三级问题等
                problemName: "",       //问题标题
                problemId: "",         //问题编码
                personName: "",        //责任人
                       //时间
            },
            //公共整改详情
            recitificatInfo: {
                problemAdviseList:[
                    // {
                    //     adviseType: "",     //意见、建议 1-建议 2-意见 3-解决方案
                    //     adviseContent: "",  //内容
                    // }
                ],  
                problemZgList: [
                    {
                        zgContent: "",          //整改措施
                        measuresName: "",       //措施类别
                        zgPersonName: "",       //整改责任人
                        zgLeaderName: "",       //整改责任主管
                        zgOrgGuidName: "",      //整改部门信息
                        zgPlanEndTime: null,    //计划完成时间
                        zgStatusName: null,     //是否完成      1-已完成    0-进行中 
                        zgSituation: "",        //实际整改情况
                    }
                ],
                applyStageName: "",             //申请事项
            },
            //公共的问题预览数据
            previewInfo: {
                problemName: '',
                degree: null,
                problemAccording: '',
                problemDesc: '',
                problemAffect: '',
                problemCauseList: [
                    // {
                    //     guid: '',
                    //     causeContent: '',
                    //     causeGuid: '',
                    //     combinationName: '',
                    //     causeType: '',
                    //     causeName: '',
                    // }
                ],
                problemAdviseList: [
                    // {
                    //     guid: '',
                    //     adviseContent: '',
                    //     adviseType: '',
                    //     adviseCategory: '',
                    //     adviseLevel: ''
                    // }
                ],
                problemZgList: [
                    // {
                    //     guid: '',
                    //     zgContent: '',
                    //     zgOrgGuidName: "",
                    //     zgPersonName: "",
                    //     zgCategory: '',
                    //     zgPerson: '',
                    //     zgLeader: '',
                    //     zgOrgGuid: '',
                    //     zgPlanEndTime: "",
                    //     zgStatus: '',
                    //     zgSituation: '',
                    //     zgOrgTreeGuid: ''
                    // }
                ],
            },
            //公共的问题详情数据
            problemDetailsData: {
                riskName: "",                   //风险名称
                riskId: "",                     //风险编号
                riskLevelName: "",              //风险等级
                auditeeOrgName: "",             //被审单位
                valueImpact: "",                //价值影响
                problemFindUserName: "",        //发现人员
                problemTrackUserName: "",       //整改追踪人
                problemTypeName: "",            //问题分类
                dateArea: "",                   //问题所属期间
                problemAccording: "",           //问题依据
                problemDesc: "",                //问题描述
                problemAffectTypeName: "",      //影响分类名
                problemAffect: "",              //影响分析
                problemCauseList: [],           //问题原因
                feedbackStatusName: "",         //是否认可
            },
            
            //整改类别分类列表
            zgCategorys: [
                /*{
                    created: 1635839116834               //创建时间
                    creator: "30a1a6ca8742467c8e1d461f6e5357c8"  //创建者id
                    creatorName: "刘石桥"                        //创建者姓名
                    guid: "a8a1670e04d046e089f3faecccb1cb71"     //guid
                    ishow: null                                  //
                    measuresContent: "请上传措施1"                //措施内容
                    measuresName: "措施1"                        //措施名称
                }*/
            ],
            //影响类型
            influenceList: [
                /*{
                    combinationName: "风险隐患:产品质量下降",
                    created: 1635419430269,
                    creator: "5d9b0c865271453ebba0c96add3b629f",
                    creatorName: "admin",
                    guid: "018b2e4fc56f42d19fe16807c2d51f7a",
                    influenceContent: "可能导致XX产品质量严重下降。",
                    influenceName: "产品质量下降",
                    influenceType: 2,
                    influenceTypeName: "风险隐患",
                    ishow: null
                }*/
            ],
        }
    },
    async created(){
        document.title = "问题详情";
        let {guid} = this.$route.query;
        //获取影响分类列表
        this.getInfluenceListDataEvent();
        //获取整改类别分类信息
        await this.getProblemZgMeasuresDataEvent();
        //获取整改详情信息
        await this.getViewByGuidDataEvent(guid);
    },
    methods:{
        //通过工号或者域账号查询用户信息
        async getUserInfoEvent(userKey){
            try {
                let res = await getUserInfo(userKey);
                return res.data.uName
            } catch(error) {
                console.log("你无聊不");
                Toast({message: error,size: "small"});
            }
        },
        //获取影响分类列表
        async getInfluenceListDataEvent(){
            try {
                let res = await getInfluenceListData();
                this.influenceList = res.data.list;
            } catch(e){
                console.log("再来一次");
                Toast({message: e,size: "small"});
            }
        },
        //获取整改类别分类信息
        async getProblemZgMeasuresDataEvent(){
            try{
                let res = await getProblemZgMeasuresData();
                this.zgCategorys = res.data.list;
            }catch(error){
                console.log("没劲")
                Toast({message: error,size: "small"});
            }
        },
        //获取整改数据信息
        async getViewByGuidDataEvent(guid){
            try{
                let res = await getViewByGuidData(guid);
                console.log("有没有搞错？");
                console.log(res);
                let data = res.data;
                this.recitificatApprovalInfo = data;
                //填充公共头部信息
                this.fillHeaderData(data);
                //填充公共整改信息
                this.fillRectificatData(data);
                //填充问题预览数据
                this.fillPreviewData(data);
                //填充问题详情数据
                this.getRiskDetailsDataEvent(data);
            }catch(error){
                console.log("来活了？");
                Toast({message: error,size: "small"});
            }
        },
        //填充公共头部信息
        fillHeaderData(data){
            this.headerInfo = {
                ...data
            }
            //标题
            this.headerInfo.title = "问题详情";
            //等级转换
            this.headerInfo.problemLevel = levelTramform(data.degree);
            this.headerInfo.personName = data.projectPmName ? data.projectPmName : "刘守纪";
        },
        //填充公共整改信息
        fillRectificatData({problemAdviseList,problemZgList,projectProblemZgApply}){
            //整改信息
            if(problemZgList && problemZgList.length > 0){
                problemZgList.forEach(item => {
                    //获取整改措施中文名
                    if(item.zgCategory){
                        item.measuresName = this.getMeasuresNameData(item.zgCategory);
                    }
                    //计划完成时间转格式
                    item.zgPlanEndTime = timeStampTransformDate(item.zgPlanEndTime);
                    //是否完成
                    item.zgStatusName = item.zgStatus == 1 ? '已完成' : '进行中';
                })
                
            }
            //申请事项
            let applyStageName = "";
            if(projectProblemZgApply && projectProblemZgApply.applyStage){
                applyStageName = applyStagesTramform(projectProblemZgApply.applyStage);
            }
            this.recitificatInfo = {
                problemAdviseList,      //意见建议
                problemZgList,          //整改信息
                applyStageName          //申请事项
            }
        },
        //填充问题预览数据
        fillPreviewData(data){
            this.previewInfo = {
                ...data
            }
            //等级转换
            this.headerInfo.problemLevel = levelTramform(data.degree);
        },
        //获取风险详情数据
        async getRiskDetailsDataEvent(data) {
            try {
                this.problemDetailsData = {
                    ...data
                }
                if(data.riskGuid){
                    let res = await getRiskDetailsData(data.riskGuid);
                    this.riskInfo = res.data;
                    this.problemDetailsData = {
                        ...this.problemDetailsData,
                        ...res.data
                        
                    }
                }

                //问题分类
                this.problemDetailsData.problemTypeName = problemTypeTramform(data.problemType);
                //问题所属期间
                this.problemDetailsData.dateArea = data.startTimeStr + "至" + data.endTimeStr;
                //获取影响分类名
                this.problemDetailsData.problemAffectTypeName = this.getProblemAffectTypeName(data.problemAffectType);

                //是否认可
                if (data.problemFeedBack && data.problemFeedBack.length > 0) {
                    this.problemDetailsData.feedbackStatusName = data.problemFeedBack[0].feedbackStatus == 1 ? '认可' : '不认可';
                } else {
                    this.problemDetailsData.feedbackStatusName = "";
                }
                
            } catch(e){
                console.log("又是你小子？");
                Toast({message: e,size: "small"});
            }
           
        },
        //通过分类guid获取措施类别中文名
        getMeasuresNameData(guid){
            let name = "";
            this.zgCategorys.forEach(item => {
                if(item.guid == guid){
                    name = item.measuresName
                }
            })
            return name
        },
        //通过影响分类guid获取类名
        getProblemAffectTypeName(guid){
            let typeName = "";
            this.influenceList.forEach(item => {
                if(guid == item.guid){
                    typeName = item.combinationName;
                }
            })
            return typeName
        }
    }
}
</script>
<style lang="less" scoped>
    .rectificat{
        padding: 15px;
        background-color: #0ea6e0;
        position: relative;
        padding-bottom: 240px;
    }
</style>